// Tokens de la marca (context/CONTEXT-brand.md) y del lenguaje visual de la app de alumnos.
// ÚNICO lugar donde se escriben colores: el resto de los archivos importa estos objetos.
export const AU = {
  azul: '#1A7FFF',
  azulHover: '#1568D9',
  azulSuave: '#EBF3FF',
  oscuro: '#0F1117',
  blanco: '#FFFFFF',
  grisClaro: '#F8FAFC',
  grisMedio: '#64748B',
  borde: '#E2E8F0',
};

// Estados de error: los mismos que usa la app de alumnos (rojo suave de Tailwind). No son colores de marca.
export const ESTADO_ERROR = {
  fondo: '#FEF2F2',
  borde: '#FCA5A5',
  texto: '#B91C1C',
};

export const FUENTE = 'Kanit, sans-serif';
export const RADIO_TARJETA = '12px';
export const RADIO_CAMPO = '10px';
// Borde de tarjetas y campos: el AU Blue al 35 % (el mismo azul de marca, más suave).
export const BORDE_AZUL = 'rgba(26, 127, 255, 0.35)';
// Sombras azules (el mismo azul de marca con transparencia): dan profundidad a la tarjeta protagonista y al botón.
export const SOMBRA_TARJETA = '0 12px 28px -10px rgba(21, 104, 217, 0.5)';
// Línea fina sobre una tarjeta rellena de azul: el azul suave al 30 %.
export const LINEA_SOBRE_AZUL = 'rgba(235, 243, 255, 0.3)';
export const SOMBRA_BOTON = '0 8px 18px -8px rgba(26, 127, 255, 0.7)';
export const ANILLO_FOCO = '0 0 0 3px rgba(26, 127, 255, 0.35)';
// Foco de teclado de los botones: contorno sólido (visible también en forced-colors), 3:1 sobre blanco.
export const CONTORNO_FOCO = { outline: `3px solid ${AU.azulHover}`, outlineOffset: '2px' };

// Oculta algo a la vista sin sacarlo del árbol de accesibilidad (p. ej. el radio real de una tarjeta).
// Propio para no depender de `@mui/utils`, que no está declarado en package.json.
export const OCULTO_VISUAL = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  width: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
};

// Etiqueta chica en mayúsculas (p. ej. "PRÓXIMO COBRO"), como en la app.
export const estiloEtiquetaChica = {
  fontFamily: FUENTE,
  fontSize: 12,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: AU.azulHover,
};
